import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { redirectedLogin } from "../../redux/actions/authActions";

const Redirected = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(params);
    dispatch(redirectedLogin(params?.id, onSuccess, onError));
    // navigate("/current-orders");
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    if (data.data.data.distributorData.email_verified == true) {
      if (data.data.data.distributorData.is_details == false) {
        navigate("/register-distribution-details");
      } else if (data.data.data.distributorData.is_contact_details == false) {
        navigate("/register-contact-details");
      } else navigate("/current-orders");
    } else {
      navigate("/email-verification-send");
    }
  };

  const onError = (err) => {
    console.log(err);
  };

  return <div>Redirecting....</div>;
};

export default Redirected;
